import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService,ModalDirective} from 'ngx-bootstrap';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {Observable} from 'rxjs';
import {GOOGLE_CAPTCHA_API_KEY} from 'src/app/app.constants';
import {Principal,StateStorageService} from 'src/app/core';
import {IUser} from 'src/app/core/user/user.model';
import {CountryMySuffixService} from 'src/app/entities/country-my-suffix';
import {CurrencyService} from 'src/app/entities/currency';
import {LanguageService} from 'src/app/entities/language';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {State} from 'src/app/shared/model/address-my-suffix.model';
import {BankInfo} from 'src/app/shared/model/bank-info.model';
import {IClientDTO} from 'src/app/shared/model/client.model';
import {ContactDetailDTO} from 'src/app/shared/model/contact-details-dto.model';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {ICurrency} from 'src/app/shared/model/currency';
import {ILanguage} from 'src/app/shared/model/language.model';
import {Accessibility} from '../model/broker.model';
import {LanguageChangeService} from '../services/language-change.service';
import {SpotClientService} from './spot-client.service';
import { CommonUtils } from '../util/common-utils';









declare var $: any;
@Component({
    selector: 'jhi-spot-client-update',
    templateUrl: './spot-client-update.component.html',
    styles: []
})
export class SpotClientUpdateComponent implements OnInit {
    @ViewChild('clientFormOTP') clientFormOTP: ModalDirective;
    @ViewChild('ngOtpInputForForm') ngOtpInputForForm: any;

    private _client: IClientDTO;
    captchaKey:string;
    confirmEmail: string;
    bsConfig: Partial<BsDatepickerConfig>;
    isOpenSuspenstion = false;
    isSaving: boolean;
    accessibilityValue = [];
    accessibilityList = [];
    emailPattern = "^(?!\.)(?!.*\.$)(?!.*?\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~\-.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$";
    index: number;
    dob: any[] = [];
    isEmailExist: boolean;
    isPolicyAvailable =false;
    confirmPassword :string;
    config = {
        backdrop: true,
        ignoreBackdropClick: true
    };

    countries: ICountryMySuffix[];
    currencies: ICurrency[];
    countriesObj = [];
    isOpenDOB: any[] = [];
    // languagesList = [
    //     {
    //         id: 'ENGLISH',
    //         name: 'English'
    //     },
    //     {
    //         id: 'GERMANY',
    //         name: 'germany'
    //     }
    // ];
    languagesList = [];
    languagesSelectedItems = [];
    languagesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen:false
    };

    countryDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };
    managerDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'fullName',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };
    userType: String = 'internal';
    auditorType: String = 'client';

    isClient = false;
    isInternalStaff = true;
    isAuditor = false;

    isAuditorClient = true;
    isAuditorCompany = false;

    internationalCallingCodeCountry = [];
    telephoneCodeCountry = [];
    faxCodeCountry = [];
    clientUsers: IUser[];
    managerDTOObj: any;
    stateObj: any;
    newPass: boolean = true;
    confrimPass:boolean = true;
    stateData:State[] = [];

    numberPattern = '^(?=.*?[1-9])[0-9()-]+$';

    isStateMandatory:boolean = false;

    // ContactDetailDTO: IContactDetailDTO[] = [];

    // effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    certificateScope: any;
    showWarning: boolean = false; 

    constructor(
        private jhiAlertService: JhiAlertService,
        private activatedRoute: ActivatedRoute,
        private spotClientService: SpotClientService,
        private countryService: CountryMySuffixService,
        private languageService: LanguageService,
        public principal: Principal,
        private currencyService: CurrencyService,
        private languageChangeService: LanguageChangeService,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private router: Router,
        private stateStorageService :StateStorageService 

    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                 window.history.back();
            }
    });
     }

    
    ngOnInit() {
       // this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);

       this.certificateScope = this.stateStorageService.getLocalStorageDataWithExpiry('spotClientSelectedScope')
       
       
        this.isEmailsSame = false;
        this.index = 0;
        // this.isOpenDOB[this.index] =  false;
        this.captchaKey = GOOGLE_CAPTCHA_API_KEY;

        this.accessibilityList = [
            {
                id: 'FULL_ACCESS',
                name: 'Full Access'
            },
            {
                id: 'PROVISIONAL_ACCESS',
                name: 'Provisional Access'
            }
        ];

        this.activatedRoute.data.subscribe(({ client }) => {
            this.client = client;
            this.client.automaticQuotation = true;
            // if (this.client.id !== undefined) {
            if (!CommonUtils.isNil(this.client.id)) {
                this.isEmailsSame = true;
                this.countriesObj.push(this.client.userDTO.addressDTO.countryDTO);
                this.managerDTOObj = [];
                this.managerDTOObj.push(this.client.managerDTO);
                // this.setMultiselctDropdownValues(this.client.contactDetails);

                // @Ganesh

                // for(let i = 0;i<this.client.contactDetails.length;i++) {
                //     this.isActivateMobileCode[i] = this.checkIsMobileOptional(this.client.contactDetails[i].contactNumber, i);
                //     this.isActivateTelephoneCode[i] = this.checkIsTelephoneReq(this.client.contactDetails[i].telephoneNumber, i);
                // }

                let i = 0;
                this.client.contactDetails.forEach(c => {

                    if (c.contactNumber !== undefined && c.contactNumber.length > 0) {
                        this.isActivateMobileCode[i] = true;
                    } else {
                        this.isActivateMobileCode[i] = false;
                    }

                    if (c.telephoneNumber !== undefined && c.telephoneNumber.length > 0) {
                        this.isActivateTelephoneCode[i] = true;
                    } else {
                        this.isActivateTelephoneCode[i] = false;
                    }
                    i++;
                });


            } else {
                this.isOpenDOB[this.index] = false;
                this.dob[this.index] = '';
                // this.client.automaticQuotation = false;
            }
            if (this.certificateScope && !(this.client.id)) {
                this.showWarning = true;
                this.client.userDTO.email = this.certificateScope.certificateRequestDTO.spotClientEmailId;
            }
        });
        if(this.client.userDTO.isPolicyAvailable){
            this.isPolicyAvailable = true;
        }
        this.bsConfig = Object.assign(
            {},
            {
                containerClass: 'custom-datepicker-theme',
                showWeekNumbers: false,
                dateInputFormat: 'DD/MM/YYYY'
            }
        );

        this.countryService
            .spotQuery({
                page: 0,
                size: 300
                // sort: null
            })
            .subscribe(
                (res: HttpResponse<ICountryMySuffix[]>) => {
                    this.countries = res.body;
                    this.setMultiselctDropdownValues(this.client.contactDetails);
                    if(this.client.userDTO.addressDTO.addressCountryId){

                        this.getStatesByCountryId(this.client.userDTO.addressDTO.addressCountryId);
                    }
                },
                (res: HttpErrorResponse) => this.onError(res.message)
            );

        // this.clientService.query().subscribe(
        //     (res: HttpResponse<IUser[]>) => {
        //         this.clientUsers = res.body;
        //     },
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );
        this.currencyService.spotQueryAll().subscribe(
            (res: HttpResponse<ICurrency[]>) => {
                this.currencies = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        this.languageService.spotQueryGetLanguages().subscribe(
            (res: HttpResponse<ILanguage[]>) => {
                this.languagesList = res.body;
                console.log(this.languagesList);
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );

        // 
        // this.languageChangeService.currentLanguage.subscribe(language => {
        //     console.log(language);
        // });

        this.fromEffeciveDate = { date: this.dateModel }

        if (this.client.accessibility == 'FULL_ACCESS') {
            this.accessibilityValue.push(this.accessibilityList[0]);
        } else if (this.client.accessibility == 'PROVISIONAL_ACCESS') {
            this.accessibilityValue.push(this.accessibilityList[1]);
        }
    }

    // set contact details DTO data
    setMultiselctDropdownValues(contactDetails) {
        for (let i = 0; i < contactDetails.length; i++) {
            this.telephoneCodeCountry[i] = new Array();
            this.internationalCallingCodeCountry[i] = new Array();
            this.faxCodeCountry[i] = new Array();
            this.countries.forEach(data => {
                if (data.id == contactDetails[i].internationalCallingCodeCountryId) {
                    this.client.contactDetails[i].internationalCallingCodeCountry = data;
                    this.internationalCallingCodeCountry[i].push(this.client.contactDetails[i].internationalCallingCodeCountry);
                }
                if (data.id == contactDetails[i].telephoneCodeCountryId) {
                    this.client.contactDetails[i].telephoneCodeCountry = data;
                    this.telephoneCodeCountry[i].push(this.client.contactDetails[i].telephoneCodeCountry);
                }
                if (data.id == contactDetails[i].faxCodeCountryId) {
                    this.client.contactDetails[i].faxCodeCountry = data;
                    this.faxCodeCountry[i].push(this.client.contactDetails[i].faxCodeCountry);
                }
            });
        }
    }

    get ContactDetailDTO() {
        return this.client.contactDetails;
    }

    // addContactDetails
    addContactDetails() {
        let dto = new ContactDetailDTO();
        let dateContent = new Date();
        this.dob.push(dateContent);
        this.ContactDetailDTO.push(dto);

        this.index = this.index + 1;
        this.dob[this.index] = '';
        this.isOpenDOB[this.index] = false;

        console.log('ADD :::: ', this.index);
    }

    // removeContactDetails
    removeContactDetails(index) {
        this.ContactDetailDTO.splice(index, 1);
        this.telephoneCodeCountry.splice(index, 1);
        this.internationalCallingCodeCountry.splice(index, 1);
        this.faxCodeCountry.splice(index, 1);
        this.dob.splice(index, 1);

        this.index = this.index - 1;
        this.isOpenDOB[this.index] = false;
        console.log('REMOVE :::: ', this.index);
    }

    // addBankDetails
    addBankDetails() {
        let dto = new BankInfo();
        this.client.bankDetails.push(dto);
    }

    // removeBankDetails
    removeBankDetails(index: number) {
        this.client.bankDetails.splice(index, 1);
        console.log('REMOVED INDEX :::: ', index);
    }

    // userType

    OnChangeUserType(data: string) {
        if (this.userType === 'internal') {
            this.isInternalStaff = true;
            this.isClient = false;
            this.isAuditor = false;
        } else if (this.userType === 'client') {
            this.isClient = true;
            this.isInternalStaff = false;
            this.isAuditor = false;
        } else {
            this.isAuditor = true;
            this.isInternalStaff = false;
            this.isClient = false;
        }
    }

    // onChangeauditorType
    onChangeauditorType(data: string) {
        if (this.auditorType === 'client') {
            this.isAuditorClient = true;
            this.isAuditorCompany = false;
        } else {
            this.isAuditorCompany = true;

            this.isAuditorClient = false;
        }
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }
    private onSuccess(message: string) {
        this.jhiAlertService.success(message, null, null);
    }

    // file upload methoddsa
    uploadFile($event) { }

    // LanguageSelect
    onLanguageSelect(event, index) {
        $(document)
            .find('#laguagesKnownid' + index)
            .find('.dropdown-list')
            .addClass('showDropdown');
    }

    onLanguageDeSelect(event, index) {
        $(document)
            .find('#laguagesKnownid' + index)
            .find('.dropdown-list')
            .addClass('showDropdown');
    }
    onDropdownClose(event, index) {
        $(document)
            .find('#laguagesKnownid' + index)
            .find('.dropdown-list')
            .removeClass('showDropdown');
    }

    // onCountrySelect
    onCountryItemSelect(event) {
        this.client.userDTO.addressDTO.countryDTO = event;
        this.client.userDTO.addressDTO.addressCountryId = event.id;
        //call api to get state list
        this.onCountryItemDeSelect(null);
        this.getStatesByCountryId(event.id);
       

    }

    onCountryItemDeSelect(event){
        this.stateData = [];
        this.stateObj = [];
    }

    stateMandatory(id){
        let flag = false;
        this.countries.map(date=>{

            if(date['isoTwo'] == 'US' && date.id==id){
                flag = true;
            return;
            }
        });
        this.isStateMandatory = flag;
    }
    getStatesByCountryId(id){

        this.countryService.getStatesByCountryIdWithoutAuth(id).subscribe(res=>{
            this.stateData =  res.body;
         });
         this.stateMandatory(id);
    }

    otpDeatisDto={
        emailId:'',
        xTDISKEYVALUE:''
    }
    saveClient() {

        if(!this.isPasswordSame  && !(this.client.id)) {
            this.jhiAlertService.error("Password and Confirm Password must be same !");
            return;
        }

        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.client.fromEffectiveDate = incDate;
       // this.openConfirmationModalForFutureRecordDeletion();
       if (!(this.client.id)) {
        this.otpDeatisDto.emailId =this.client.userDTO.email;
        this.otpDeatisDto.xTDISKEYVALUE = 'oZP8ZqWxCY65ndFAh0kk3b1H5qgrVbwA';
        this.spotClientService.generateOTP('/generate-otp',this.otpDeatisDto).subscribe(res=>{
            console.log(res.body.status);
            if(res.body.status == "SUCCESS"){
                this.onSuccess(res.body.message);
                this.showclientFormOTP();
            }else{
            this.onError("Some thing went wrong.");
            }
            
            },err=>{});
        }else{
            this.saveOrUpdate();
        }
      //  }
       
     

    }
    otpConfirmation(){
          this.saveOrUpdate();
    }
    saveOrUpdate() {
        this.isSaving = true;
        // if (this.client.id !== undefined) {
        if (!CommonUtils.isNil(this.client.id)) {
        } else {
            //  this.client.contactDetailDTO.internationalCallingCodeCountry = this.client.contactDetailDTO.internationalCallingCodeCountry[0];
            this.client.userDTO.addressDTO.addressCountryId = this.countriesObj[0].id;
            this.client.userDTO.addressDTO.countryDTO = this.countriesObj[0];
        }
        this.client.accessibility = Accessibility.FULL_ACCESS;
        this.client.userDTO.authorities = ['SPOT_CLIENT'];
        // this.client.userDTO.email = this.client.contactDetails[0].emailAddress;
        this.client.userDTO.login = this.client.userDTO.email;
        this.client.userDTO.firstName = this.client.contactDetails[0].name;
      //  this.client.managerDTO = this.managerDTOObj[0];
        if(this.stateObj && this.stateObj.length>0){
            this.client.userDTO.addressDTO .state = this.stateObj[0];
        }else{
            this.client.userDTO.addressDTO .state = null;
        }
        // this.client.laguagesKnown = this.client.laguagesKnown[0];

        for (let i = 0; i < this.dob.length; i++) {
            //  this.client.contactDetails[i].dateOfBirth = moment(this.dob[i], DATE_TIME_FORMAT);
        }

        // if (this.client.id !== undefined) {
        if (!CommonUtils.isNil(this.client.id)) {
            this.subscribeToSaveResponse(this.spotClientService.spotClientUpdate(this.client));
        } else {
            this.subscribeToSaveResponse(this.spotClientService.createSpotClient(this.client));
        }
        // this.subscribeToSaveResponse(this.clientService.create(this.client));
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IClientDTO>>) {
        result.subscribe((res: HttpResponse<IClientDTO>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onSaveSuccess() {
        this.isSaving = false;
      //  this.deleteExistedFutureRecordDetails();
      if(this.principal.authority){
        // this.router.navigateByUrl('/dashboard');
        this.router.navigateByUrl('/spot_client/'+this.client.id+'/view');
      }else{
        this.router.navigateByUrl('/login');
      }
       
        //  this.previousState();
    }

    private onSaveError(res) {
        this.isSaving = false;
        if (res && res.error) {
            if (res.error.payload) {
                this.onError(res.error.payload);
            } else {
                this.onError(res.error.message);
            }
        }
    }
    previousState() {
        window.history.back();
    }

    get client() {
        return this._client;
    }

    set client(client: IClientDTO) {
        this._client = client;
        this.stateObj = [];

       if(client.userDTO && client.userDTO.addressDTO ){
           if(client.userDTO.addressDTO.state && client.userDTO.addressDTO.state.id){
            this.stateObj.push(client.userDTO.addressDTO.state);
           }
           if(this.client.userDTO.addressDTO.countryDTO){
            this.isStateMandatory = (this.client.userDTO.addressDTO.countryDTO.isoTwo == 'US' );
           }
       } 
      
    } 
    setDateFormat(dateContent, index) {
        this.dob[index] = new Date(dateContent);
    }

    onCountrySelect(event, index, elementType) {
        this.countries.forEach(data => {
            if (event.id == data.id) {
                if (elementType === 'faxNumber') {
                    this.client.contactDetails[index].faxCode = data.code;
                    this.client.contactDetails[index].faxCodeCountry = data;
                    this.client.contactDetails[index].faxCodeCountryId = data.id;
                } else if (elementType === 'mobileNumber') {
                    this.client.contactDetails[index].internationalCallingCode = data.code;
                    this.client.contactDetails[index].internationalCallingCodeCountry = data;
                    this.client.contactDetails[index].internationalCallingCodeCountryId = data.id;
                } else {
                    this.client.contactDetails[index].telephoneCode = data.code;
                    this.client.contactDetails[index].telephoneCodeCountry = data;
                    this.client.contactDetails[index].telephoneCodeCountryId = data.id;
                }
            }
        });
    }
    onCountryDeSelect(event, index, elementType) {
        // @Ganesh

        if (elementType === 'faxNumber') {
            this.client.contactDetails[index].faxCode = null;
            this.client.contactDetails[index].faxCodeCountry = null;
            this.client.contactDetails[index].faxCodeCountryId = null;
        } else if (elementType === 'mobileNumber') {
            this.client.contactDetails[index].internationalCallingCode = null;
            this.client.contactDetails[index].internationalCallingCodeCountry = null;
            this.client.contactDetails[index].internationalCallingCodeCountryId = null;
        } else {
            this.client.contactDetails[index].telephoneCode = null;
            this.client.contactDetails[index].telephoneCodeCountry = null;
            this.client.contactDetails[index].telephoneCodeCountryId = null;
        }

        this.checkIsMobileOptional(this.client.contactDetails[index].contactNumber, index);
        this.checkIsTelephoneReq(this.client.contactDetails[index].telephoneNumber, index);
        this.checkIsFaxOptional(this.client.contactDetails[index].fax, index);


    }

    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode == 46) {
            return true;
        } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        } else return true;
    }

    trackCountryByCurrency(index: number, item: ICountryMySuffix) {
        return item.currency;
    }

    getSelectedCurrency(selectedVals: any, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.currency === selectedVals[i].currency) {
                    return selectedVals[i];
                }
            }
        }
        return option.id;
    }

    updateBackCurrency(bank, currencyId) {
        this.currencies.forEach(data => {
            if (currencyId == data.id) {
                bank.currencyCode = data.name;
                bank.currencyDTO = data;
            }
        });
    }

    isEmailsSame: boolean;
    checkEmailAndConfirmEmail(event) {
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
        let confirmMail: string = this.client.userDTO.email;
        if (confirmMail.toLowerCase() == event.target.value.toLowerCase()) {
            this.isEmailsSame = true;
            console.log('Is Emails Same ', this.isEmailsSame);
        } else {
            this.isEmailsSame = false;
            console.log('Is Emails Same ', this.isEmailsSame);
        }
    }

    

    checkEmailAndConfirmEmail2(event) {
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
        let mail: string = this.confirmEmail;
        if (mail.toLowerCase() == event.target.value.toLowerCase()) {
            this.isEmailsSame = true;
            console.log('Is Emails Same ', this.isEmailsSame);
        } else {
            this.isEmailsSame = false;
            console.log('Is Emails Same ', this.isEmailsSame);
        }
    }

    isPasswordSame: boolean;
    checkPasswordAndConfirmPassword(event){
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
        let confirmPassword: string = this.client.userDTO.password;
        if (confirmPassword== event.target.value) {
            this.isPasswordSame = true;
            console.log('Is Emails Same ', this.isPasswordSame);
        } else {
            this.isPasswordSame = false;
            console.log('Is Emails Same ', this.isPasswordSame);
        }
    }

    checkPasswordAndConfirmPassword2(event){
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
        let password: string = this.confirmPassword;
        if (password == event.target.value) {
            this.isPasswordSame = true;
            console.log('Is Emails Same ', this.isPasswordSame);
        } else {
            this.isPasswordSame = false;
            console.log('Is Emails Same ', this.isPasswordSame);
        }
    }
    // @Ganesh
    //  isActivateMobileCode[i],isActivateTelephoneCode[i]
    //   (blur)="checkIsTelephoneReq($event.target.value,i)"
    //  (blur)="checkIsMobileOptional($event.target.value,i)"
    // (blur)="checkIsFaxOptional($event.target.value,i)"

    isActivateMobileCode = [];
    isActivateTelephoneCode = [];
    isActivateFaxCode = [];

    checkIsTelephoneReq(event, index) {
        event = this.client.contactDetails[index].telephoneNumber;
        if (event !== undefined && event.length > 0) {
            this.isActivateTelephoneCode[index] = true;
        } else {
            this.isActivateTelephoneCode[index] = false;
        }

        console.log('TEL :: ', this.isActivateTelephoneCode);
    }

    checkIsMobileOptional(event, index) {
        event = this.client.contactDetails[index].contactNumber;
        if (event !== undefined && event.length > 0) {
            this.isActivateMobileCode[index] = true;
        } else {
            this.isActivateMobileCode[index] = false;
        }

        console.log('MOB :: ', this.isActivateMobileCode);
    }
    trimField(event){
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
    }
    // method for allow alphabets and space and DOT symbol
    customContactNameRegularExpression(event) {
        const charCode = event.which ? event.which : event.keyCode;
        let value = event.target.value;
        let findLengthOfDotSymbol = 0;
        if (value.length > 0) {
            let array = value.split('');
            findLengthOfDotSymbol = array.filter(l => l === '.').length;
            console.log(findLengthOfDotSymbol, "findLengthOfDotSymbol");
        }
        // for allow only one dot 
        if (charCode == 46 && findLengthOfDotSymbol > 0) {
            return false
        }

        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32 || charCode == 46) {
            return true;
        }
        else {
            return false;
        }
    }
    checkIsFaxOptional(event, index) {
        event = this.client.contactDetails[index].fax;
        if (event !== undefined && event.length > 0) {
            this.isActivateFaxCode[index] = true;
        } else {
            this.isActivateFaxCode[index] = false;
        }

        console.log('TEL :: ', this.isActivateFaxCode);
    }

    //  Method For Validating The Only String Without any Characters
    // (keypress)="blockSpecChars($event)"
    blockSpecChars(event) {
        const charCode = event.which ? event.which : event.keyCode;

        if (
            (charCode >= 33 && charCode <= 47) ||
            (charCode >= 58 && charCode <= 64) ||
            (charCode >= 91 && charCode <= 96) ||
            (charCode >= 123 && charCode <= 126)
        ) {
            return false;
        } else {
            return true;
        }
    }

    trackId(index: number, item: ContactDetailDTO) {
        return index;
    }

    trackIdByBankDetails(index: number, item: any) {
        return index;
    }



    isChecked = true;

    setAutomaticQuotation(status) {
        this.client.automaticQuotation = null;

        if (status === 'CHECKED') {
            this.client.automaticQuotation = true;
        } else if (status === 'UNCHECKED') {
            this.client.automaticQuotation = false;
        }
    }

    trimContactPersonName(event, index) {
        if (this.ContactDetailDTO[index].name) {
            this.ContactDetailDTO[index].name = this.ContactDetailDTO[index].name.trim();
        }
    }

    trimBranch(event, index) {
        this.ContactDetailDTO[index].officeLocation = this.ContactDetailDTO[index].officeLocation.trim();
    }

    trimCompanyName(event) {
        if (this.client.companyName) {
            this.client.companyName = this.client.companyName.trim();
        }
    }

    trimStreetAddress(event) {
        if (this.client.userDTO.addressDTO.streetAddress) {
            this.client.userDTO.addressDTO.streetAddress = this.client.userDTO.addressDTO.streetAddress.trim();
        }
    }

    trimAddressLine(event) {
        if (this.client.userDTO.addressDTO.addressLine) {
            this.client.userDTO.addressDTO.addressLine = this.client.userDTO.addressDTO.addressLine.trim();
        }
    }

    trimCity(event) {
        if (this.client.userDTO.addressDTO.city) {
            this.client.userDTO.addressDTO.city = this.client.userDTO.addressDTO.city.trim();
        }
    }

    trimHolderName(event, index) {
        if (this.client.bankDetails[index].holderName) {
            this.client.bankDetails[index].holderName = this.client.bankDetails[index].holderName.trim();
        }
    }


    trimZip(event) {
        if (this.client.userDTO.addressDTO.postalCode) {
            this.client.userDTO.addressDTO.postalCode = this.client.userDTO.addressDTO.postalCode.trim();
        }
    }

    trimAccountNumber(event, index) {
        if (this.client.bankDetails[index].accountNumber) {
            this.client.bankDetails[index].accountNumber = this.client.bankDetails[index].accountNumber.trim();
        }
    }

    trimBIC(event, index) {
        if (this.client.bankDetails[index].bicCode) {
            this.client.bankDetails[index].bicCode = this.client.bankDetails[index].bicCode.trim();
        }
    }
    // get authority() {
    //     return this.principal.userIdentity.authorities[0];
    // }

    onAccessibilityItemSelect(event) {
        console.log(event.id);
        if (event.id == 'FULL_ACCESS') {
            this.client.accessibility = 'FULL_ACCESS';
        } else if (event.id == 'PROVISIONAL_ACCESS') {
            this.client.accessibility = 'PROVISIONAL_ACCESS';
        }

    }


   

    // global modal open and close event
    bsModalRef: BsModalRef;
    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    // openConfirmationModalForFutureRecordDeletion() {
    //     this.isConfirmDeletion = false;
    //     if (this.client.id !== null && this.client.id !== undefined) {
    //         let form_data = {
    //             masterId: this.client.id,
    //             futureDataType: FutureDataType.CLIENT.valueOf(),
    //             fromEffectiveDateFormatted: this.client.fromEffectiveDate
    //         }
    //         this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
    //             const resBody = response.body;
    //             if (resBody.isSuccess) {
    //                 const initialState = {
    //                     title: 'client (' + this.client.userDTO.email + ')',
    //                     message: resBody.message,
    //                 };
    //                 this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
    //                 this.bsModalRef.content.onClose.subscribe(result => {
    //                     if (result) {
    //                         this.isConfirmDeletion = true;
    //                         this.saveOrUpdate();
    //                     }
    //                 });
    //             } else {
    //                 this.saveOrUpdate();
    //             }
    //         });

    //     } else {
    //         this.saveOrUpdate();
    //     }
    // }


    // deleteExistedFutureRecordDetails() {
    //     if (this.isConfirmDeletion) {
    //         let form_data = {
    //             masterId: this.client.id,
    //             futureDataType: FutureDataType.CLIENT.valueOf(),
    //             fromEffectiveDateFormatted: this.client.fromEffectiveDate
    //         }
    //         this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
    //             console.log(response);
    //             this.isConfirmDeletion = false;
    //         });
    //     }
    // }

    resolved(captchaResponse: string) {
        console.log(`Resolved captcha with response: ${captchaResponse}`);
    }

    showNewPassword(event){
        this.newPass = !this.newPass;
    }
    showConfrimPassword(){
        this.confrimPass = !this.confrimPass;
    }

    showclientFormOTP(){
        this.clientFormOTP.show();
    }
      
    hideClientFormOTP(){
        this.clientFormOTP.hide();
    }
    hideClientFormOTPAndReset(){
        this.hideClientFormOTP();
        this.ngOtpInputForForm.setValue(null);
        this.client.oneTimePassword = null;
    }

    onOtpChange(event){
        console.log(event);
        if(event.length==6){
          this.client.oneTimePassword = event;
        }else{
          this.client.oneTimePassword = null;
        }        
      }
      
    otpResend(){
        console.log("test");
      if (!(this.client.id)) {
        this.otpDeatisDto.emailId =this.client.userDTO.email;
        this.otpDeatisDto.xTDISKEYVALUE = 'oZP8ZqWxCY65ndFAh0kk3b1H5qgrVbwA';
        this.spotClientService.generateOTP('/resend-otp',this.otpDeatisDto).subscribe(res=>{
            console.log(res.body.status);
            if(res.body.status == "SUCCESS"){
                this.ngOtpInputForForm.setValue(null);
                this.client.oneTimePassword = null;
                this.onSuccess(res.body.message);
            }else{
                this.onError("Some thing went wrong.");
            }
            
            },err=>{});
        }
    }
      
}

